module.exports = __webpack_public_path__ + "static/media/comprovanteOk.43a1f1eb.jpg";